// Mock data for the Meilleurelec.fr comparateur clone (frontend-only)

// Helper: build a tel: href from a French display number.
// e.g. "09 70 25 21 97" -> "tel:+33970252197"
export const toTel = (num) =>
  "tel:0033" + String(num).replace(/\D/g, "").replace(/^0/, "");

// Canonical public phone numbers (data-dest / displayed numbers from the
// original page). NOTE: the live site swaps these for dynamic call-tracking
// numbers (DNI) via JavaScript; we use the canonical public numbers here.
export const PHONES = {
  main: "09 70 25 21 97",
  urgences: "09 70 25 13 00",
  moving: "09 70 25 21 97",
  conseiller: "09 70 25 21 97",
  compare: "09 70 25 21 97",
  finalCta: "09 70 25 21 97",
  souscription: "09 70 25 21 97",
  enedis: "09 70 83 19 70",
  grdf: "0 800 47 33 33",
};

// Electricity providers shown in the carousel
export const PROVIDERS = [
  { id: "octopus", name: "Octopus", logo: "/logos/providers/octopus.png", price: "0,1856 \u20ac / kWh", hasStar: true },
  { id: "total", name: "TotalEnergies", logo: "/logos/providers/total.png", price: "0,1891 \u20ac / kWh", hasStar: true },
  { id: "edf", name: "EDF (offre march\u00e9)", logo: "/logos/providers/edf.png", price: "0,1856 \u20ac / kWh", hasStar: true },
  { id: "ekwateur", name: "Ekwateur", logo: "/logos/providers/ekwateur.png", price: "0,1718 \u20ac / kWh", hasStar: true },
  { id: "engie", name: "Engie", logo: "/logos/providers/engie.png", price: "0,2183 \u20ac / kWh", hasStar: true },
  { id: "grdf", name: "GRDF", logo: "/logos/providers/grdf.png", price: "Gestionnaire de r\u00e9seau", hasStar: false },
  { id: "ilek", name: "Ilek", logo: "/logos/providers/ilek.png", price: "0,1949 \u20ac / kWh", hasStar: true },
  { id: "enedis", name: "Enedis", logo: "/logos/providers/enedis.png", price: "Gestionnaire de r\u00e9seau", hasStar: false },
  { id: "eni", name: "ENI (Plenitude)", logo: "/logos/providers/eni.png", price: "0,1855 \u20ac / kWh", hasStar: true },
  { id: "mint", name: "Mint \u00c9nergie", logo: "/logos/providers/mint.png", price: "\u2248 TRV (0,1952 \u20ac)", hasStar: true },
  { id: "ohm", name: "OHM \u00c9nergie", logo: "/logos/providers/ohm.png", price: "0,1728 \u20ac / kWh", hasStar: true },
  { id: "vattenfall", name: "Vattenfall", logo: "/logos/providers/vattenfall.png", price: "0,1872 \u20ac / kWh", hasStar: true },
  { id: "alpiq", name: "Alpiq", logo: "/logos/providers/alpiq.png", price: "0,1793 \u20ac / kWh", hasStar: true },
];

// Static images (optimized, hosted locally in /public for SEO & performance)
export const IMAGES = {
  logo: "/logos/meilleurelec.png",
  partners: "/logos/partners.png",
  enedisHeader: "/logos/enedis-header.png",
  erdfEnedis: "/logos/erdf-enedis.png",
  moving: "/images/demenagement.webp",
};

// Feature cards
export const FEATURES = [
  {
    id: "assistance",
    icon: "phone",
    title: "Assistance t\u00e9l\u00e9phonique 100% gratuite",
    text: "Nous vous aidons a trouver l'offre qui s'adapte au mieux \u00e0 vos besoins.",
  },
  {
    id: "economies",
    icon: "savings",
    title: "Des \u00e9conomies d\u00e8s la premi\u00e8re facture",
    text: "En choisissant la meilleure offre, il est possible de r\u00e9duire le montant total de votre facture d'\u00e9lectricit\u00e9.",
  },
  {
    id: "exclusives",
    icon: "globe",
    title: "Offres exclusives et \u00e9nergies renouvelables",
    text: "Parfois, nous proposons des tarifs exclusifs et in\u00e9dits parmi les moins chers du march\u00e9.",
  },
];

// Footer & legal links (real URLs from the original page)
export const FOOTER_LINKS = {
  cgu: "https://particuliers.meilleurelec.fr/cgu",
  cookie: "https://particuliers.meilleurelec.fr/cookie",
  cookiePolicy: "https://www.meilleurelec.fr/cookie",
  googlePrivacy: "https://business.safety.google/privacy/",
};

export const PRICE_NOTE =
  "Prix indicatif (option Base 6 kVA) en vigueur autour du 10/09/2025, susceptibles d'\u00e9voluer selon l'offre, l'abonnement et le profil. Le prix final ne change pas si nous sommes r\u00e9mun\u00e9r\u00e9s par un fournisseur.";
